var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoldenTick = function SvgGoldenTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#827127",
    d: "m7.262 9.974 1.702 2.953c1.764-2.826 3.745-5.302 5.54-6.73.403-.382 1.022-.16.588.253-2.011 2.127-3.559 4.54-5.137 8.318-.62.444-1.331.666-1.672.254l-2.228-4.096c-.31-.508.774-1.682 1.207-.952"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#82722D",
    d: "M3.164 2.982c6.728-6.434 17.623-1.773 17.835 7.466.086 7.442-7.533 12.57-14.42 9.782C-.49 17.413-2.232 8.289 3.163 2.982m.499.495c-6.047 6.192-1.673 16.717 6.97 16.838 7.079.098 11.992-7.189 9.328-13.732C17.308.038 8.546-1.602 3.663 3.477"
  })));
};
export default SvgGoldenTick;